import React, { useEffect } from 'react';
import EnquiryModal from './EnquiryModal';

export const ContactModal = ({ open, onClose, contacts, title, property, isMobile }) => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = open ? 'hidden' : '';
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
      }
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={!isMobile ? "pdm-back pdm-center" : "pdm-back"}
      onClick={(e) => {
        if (e.target.classList.contains("pdm-back")) {
          onClose();
        }
      }}
    >
      <div
        className={!isMobile ? "pdm-modal" : "pdm-sheet"}
        onClick={e => e.stopPropagation()}
      >
        <div className="pdm-pill" />
        <div className="pdm-head">
          <div>
            <p className="pdm-title">{title}</p>
            <p className="pdm-sub">Choose how you'd like to connect</p>
          </div>
          <button className="pdm-x" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className="pdm-body-scroll" style={{ maxHeight: '70vh', overflowY: 'auto', padding: '1rem' }}>
          {title === "Send Enquiry" ? (
            <EnquiryModal property={property} onClose={onClose} />
          ) : (
            contacts && contacts.length > 0 ? (
              contacts.map((c, i) => (
                <div key={i} className="pdm-row" style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem', borderBottom: '1px solid #f1f5f9' }}>
                  <div className="pdm-av" style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#2563eb', color: '#fff', display: 'flex', alignItems: 'center', justifyCenter: 'center', fontSize: '1.25rem', fontWeight: 600 }}>
                    {c.name ? c.name[0].toUpperCase() : '?'}
                  </div>
                  <div className="pdm-info" style={{ flex: 1 }}>
                    <div className="pdm-name" style={{ fontWeight: 600, fontSize: '0.9375rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      {c.name}
                      {c.isAdmin && <span className="pdm-tag" style={{ background: '#f1f5f9', color: '#64748b', fontSize: '0.625rem', padding: '0.125rem 0.375rem', borderRadius: '0.25rem' }}>Admin</span>}
                    </div>
                    <div className="pdm-phone" style={{ color: '#64748b', fontSize: '0.8125rem' }}>{String(c.phone || '')}</div>
                  </div>
                  <div className="pdm-btns" style={{ display: 'flex', gap: '0.5rem' }}>
                    <a href={`tel:${String(c.phone || '')}`} className="pdm-btn pdm-call" style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', background: '#f8fafc', border: '1px solid #e2e8f0', color: '#1e293b', fontSize: '0.8125rem', fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.5 1.17 2 2 0 012.5.5h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.01a16 16 0 006.06 6.06l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                      </svg>
                      Call
                    </a>
                    <a href={`https://wa.me/91${String(c.phone || '').replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" className="pdm-btn pdm-wa" style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', background: '#25D366', color: '#fff', fontSize: '0.8125rem', fontWeight: 600, textDecoration: 'none' }}>WhatsApp</a>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>No contact available</div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
